export default __webpack_public_path__ + "static/media/icon-movimentacao.f01f0183.svg";